<template>
  <div>
    <el-row class="tac" type="flex">
      <el-col :span="24" class="layout-header">
        <div class="layout-header-logo">
          <img :src="lkdLogo" style="height: 50px;margin-top: 5px">
          <!-- <img src="@/assets/images/lkdWhite.png" style="height: 50px;margin-top: 5px"> -->
          <!-- <img src="@/assets/images/标志+新开普（左右）白字透明底.png" style="height: 50px;margin-top: 5px"> -->
          <!-- <img src="@/assets/images/yunpengLogin.png" style="height: 50px;margin-top: 5px"> -->
        </div>
        <span style="margin-right: 150px;color: white">打印预览&nbsp;&nbsp;<i class="el-icon-close" @click="back"
            style="color: white"></i></span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="2" :offset="4" style="margin-top: 20px">
        <h4 style="text-align: center">打印预览</h4>
      </el-col>
      <el-col :span="2" :offset="14" style="margin-top: 20px">
        <i class="el-icon-close" @click="back"></i>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="2" :offset="22">
        <el-button size="small" style="margin-right:30px;margin-bottom: 20px" type="danger" @click="printPreview()">打印
        </el-button>
      </el-col>
    </el-row>
    <div id="subOutputRank-print" style="margin: 0 auto; width: 400px;">
      <template v-for="(item, index) in data">
        <v-tax :Data="item" :key="index"></v-tax>
      </template>
    </div>
    <el-row>
      <el-col :span="2" :offset="22">
        <el-button size="small" style="margin-right:30px;margin-bottom: 20px" type="danger" @click="printPreview()">打印
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import VTax from '@/components/orderPrint/sortingDetailsPrintTax';
import http from '../../assets/common/http';

export default {
  data() {
    return {
      data: JSON.parse(sessionStorage.getItem('sortingDetails')),
      lkdLogo: this.$util.publicLogo() || '',
    };
  },
  components: {
    VTax,
  },
  created() {},
  methods: {
    back() {
      window.history.back(-1);
    },
    async printPreview() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const resList = [];
          const errorList = [];
          for (const item of this.data) {
            const params = {
              SERVICE_ID: '10003',
              OTYPE: 45,
              ORDER_DETAIL_ID: item.ORDER_DETAIL_ID,
            };
            try {
              // eslint-disable-next-line no-await-in-loop
              resList.push(await http.post(params));
            } catch (err) {
              errorList.push(err);
            }
          }
          if (errorList.length) {
            this.$message.show({ text: errorList[0], type: 'error' });
          } else {
            this.$message.show({ text: '操作成功', type: 'success' });
            const subOutputRankPrint = document.getElementById('subOutputRank-print');
            const newContent = subOutputRankPrint.innerHTML;
            const oldContent = document.body.innerHTML;
            document.body.innerHTML = newContent;
            this.print(newContent).close();
            window.location.reload();
            document.body.innerHTML = oldContent;
            document.body.style.cursor = 'default';
          }
        } catch (err) {
          // eslint-disable-next-line no-console
          console.log(err);
        } finally {
          document.body.style.cursor = 'default';
        }
      }
    },
    print(content, isRow = true, w = null, h = null) {
      const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
      const dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;
      const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
      const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
      w = +w === 0 ? width : w;
      h = +h === 0 ? height : h;
      const left = ((width / 2) - (w / 2)) + dualScreenLeft;
      const top = ((height / 2) - (h / 2)) + dualScreenTop;
      const myWindow = window.open('', '打印', `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=yes, copyhistory=no, width=${w}, height=${h}, top=${top}, left=${left}`);
      // 打印表格样式
      // let style = "<style type='text/css'>.main{height:43px;} .title {font-size: 30px;text-align: center; margin-bottom: 15px} .head{width: 100%; display: flex; justify-content: space-between;margin-bottom: 15px} .divFooter{position: fixed; display: flex; justify-content: space-between;bottom: 0;}.divFooter>div{margin-right: 100px} table{width: 100%} table.el-table__body {width: 600px;font-family: verdana,arial,sans-serif;font-size:11px;color:#333333;border-width: 1px;border-color: #666666;border-collapse: collapse}table.el-table__body, table.el-table__header th {border-width: 1px;padding: 5px;border-style: solid;border-color: #666666;background-color: #dedede}table.el-table__body td {border-width: 1px;padding: 5px;border-style: solid;border-color: #666666;background-color: #ffffff}}</style>"
      const style = `
        <style type='text/css'>
          *{
            margin: 0;
            padding: 0;
          }
          .name{
            font-size: 12px;
          }
          /* @media print{
            .container {
              page-break-after: always;
            }
          } */
          .container{
            font-size: 12px;
            margin: 0 auto;
            width: 60mm;
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .center{}
          .two_line{
            display: flex;
            justify-content: space-between;
          }
          .shop_name{}
        </style>
      `;
      myWindow.document.write(content + style);
      myWindow.focus();
      myWindow.document.close(); // 关闭document的输出流, 显示选定的数据
      myWindow.print.portrait = isRow;
      myWindow.print(); // 打印当前窗口
      return myWindow;
    },
  },
};
</script>
<style scoped>
.ma img {
  width: 105px;
}

ul {
  list-style: none;
  min-height: 100px;
  padding: 0;
}

li {
  margin-bottom: 0;
  line-height: 25px;
  font-size: 14px;
}

p {
  font-size: 14px;
}

/* #subOutputRank-print {
  width: 284mm;
}

@media print {
  .page-break {
    page-break-after: always;
  }
} */

.layout-header {
  z-index: 10;
  position: fixed;
  width: 100%;
  background: linear-gradient(#373737, #464c5b);
  line-height: 60px;
  text-align: right;
  border-bottom: 1px solid #505664;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}

.layout-header-logo {
  height: 60px;
  width: 210px;
  float: left;
}

.layout-header-logo img {
  width: 90%;
  margin-right: 5%;
  height: 60px;
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/orderPrint/sortingDetailsPrint.vue